function localKMatrix(L, EA, EI) {

    var kloci = ([[EA/L, 0, 0, -EA/L, 0, 0],
    [0, (12*EI)/(L**3), (6*EI)/(L**2), 0, -(12*EI)/(L**3), (6*EI)/(L**2)],
    [0, (6*EI)/(L**2), (4*EI)/L, 0, -(6*EI)/(L**2), (2*EI)/L],
    [-EA/L, 0, 0, EA/L, 0, 0],
    [0, -(12*EI)/(L**3), -(6*EI)/(L**2), 0, (12*EI)/(L**3), -(6*EI)/(L**2)],
    [0, (6*EI)/(L**2), (2*EI)/L, 0, -(6*EI)/(L**2), (4*EI)/L]])

    // var kloci = ([[EA/L, 0, 0, -EA/L, 0, 0],
    // [0, (12*EI)/(L**3), (6*EI)/(L**2), 0, -(12*EI)/(L**3), (6*EI)/(L**2)],
    // [0, (6*EI)/(L**2), (4*EI)/L, 0, -(6*EI)/(L**2), (2*EI)/L],
    // [-EA/L, 0, 0, EA/L, 0, 0],
    // [0, -(12*EI)/(L**3), -(6*EI)/(L**2), 0, (12*EI)/(L**3), -(6*EI)/(L**2)],
    // [0, (6*EI)/(L**2), (2*EI)/L, 0, -(6*EI)/(L**2), (4*EI)/L]])

    //console.log(kloci)
    return kloci
}

export default localKMatrix